import { render, staticRenderFns } from "./dictdes.vue?vue&type=template&id=662c5808"
import script from "./dictdes.vue?vue&type=script&lang=js"
export * from "./dictdes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports